import { render, staticRenderFns } from "./revisions-tab.vue?vue&type=template&id=3f5f1810&"
import script from "./revisions-tab.vue?vue&type=script&lang=js&"
export * from "./revisions-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports